module.exports = __webpack_public_path__ + "static/media/09b.23aa56c1.png";